import { jsx as _jsx, Fragment as _Fragment } from "preact/jsx-runtime";
import { render } from 'preact';
import UserDetailComponent from './UserDetailComponent';
const UserComponent = () => {
    return (_jsx(_Fragment, { children: _jsx(UserDetailComponent, {}, void 0) }, void 0));
};
document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('#LoginUserForm');
    if (root) {
        render(_jsx(UserComponent, {}, void 0), root);
    }
});
